// @flow
import { useContext } from 'react';

import ShopCartContext from './ShopCartContext';


const useShopCartContext = () => useContext(ShopCartContext);

export default useShopCartContext;
